import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import QuizFlow1 from '../components/quiz/flow1/QuizFlow1'
import { withRouter } from 'next/router'
import { GlobalStyle, colors } from '@components/shared'
import TopNav from '@components/TopNav'
import { BannerText, TopBanner } from '@components/quiz/quizStyles'
import ConversionPaywallModal from '@components/subscribe/ConversionPaywallModal'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { dismissIntercom } from '@services/intercom'

type PropsType = {
  bannerText: string,
  isBannerVisible: boolean
}

type DispatchPropsType = {}

function HunkQuiz20 (_props: PropsType & DispatchPropsType): React.ReactNode {
  return (
    <HunkQuizFlow
      isBannerVisible={true}
      bannerText='You’re one step closer to getting 20% off'
      subscriptionOfferCta='TRY 7 DAYS FREE'
      subscriptionOfferTitle='<s>$69.99</s> $55.99 for 1 year of Dipsea'
      subscriptionOfferSubtitle='Discounted subscription of $55.99 USD billed at 7-day trial end'
      subscriptionOfferSubtext='Your card will be charged a sum of $55.99 USD in one week for the first year of unlimited access to Dipsea. You must cancel your subscription before the end of your one week trial if you do not want to be charged. Your annual subscription will auto-renew for $69.99 USD thereafter until you cancel. By clicking "Try 7 Days Free", you agree to our Payment Terms.'
      existingPromoCode='hunk-quiz-20'
    />
  )
}

const mapStateToProps = (): any => {
  return {}
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HunkQuiz20) as any
) as any

export const HunkQuizFlow = (props: {
  isBannerVisible: boolean,
  bannerText?: string,
  subscriptionOfferCta: string,
  subscriptionOfferTitle: string,
  subscriptionOfferSubtitle: string,
  subscriptionOfferSubtext: string,
  existingPromoCode: string,
  bannerBackground?: string
}): React.ReactNode => {
  const isIntercomVisible = typeof window !== 'undefined' && window.Intercom
  React.useEffect((): void => {
    if (isIntercomVisible) {
      dismissIntercom()
    }
  }, [isIntercomVisible])

  const isLongBannerText = props.bannerText && props.bannerText.length > 70

  return (
    <PageWrapper isBannerVisible={props.isBannerVisible} isLongBannerText={isLongBannerText}>
      <GlobalStyle backgroundColor={colors.midnightBlue} />
      <HtmlHead
        title={`Dipsea | Sexy Audio Stories With Characters You'll Love`}
        description={
          'Take the quiz and unlock unlimited access to hundreds of sexy audio stories, sleep scenes, and wellness sessions. Answer a few questions and start listening.'
        }
      />

      {props.isBannerVisible && !!props.bannerText && (
        <TopBanner bannerBackground={props.bannerBackground} className='top-banner'>
          <TagIcon />
          <BannerText marginLeft={12}>{props.bannerText}</BannerText>
        </TopBanner>
      )}

      <TopNav
        backgroundColor={colors.midnightBlue95}
        isAssetLoaded={true}
        isMarketingNav={true}
        isPromoModal={true}
        isStatic
      />

      <ConversionPaywallModal
        subtype={'annual'}
        defaultSignIn={true}
        subscriptionOfferCta={props.subscriptionOfferCta}
        subscriptionOfferTitle={props.subscriptionOfferTitle}
        subscriptionOfferSubtitle={props.subscriptionOfferSubtitle}
        subscriptionOfferSubtext={props.subscriptionOfferSubtext}
        existingPromoCode={props.existingPromoCode}
      />

      <QuizFlow1 quizType='hunk-quiz' />
    </PageWrapper>
  )
}

const PageWrapper = styled.div<any>`
  .top-banner {
    height: ${(props: { isLongBannerText: boolean }): number => props.isLongBannerText ? 65 : 32}px;
    ${(props: any): any => config(props).media.md`
      height: 56px;
    `}
  }

  .quiz-block {
    padding:  ${(props: { isLongBannerText: boolean }): number => props.isLongBannerText ? 120 : 90}px 20px 30px;
    ${(props: any): any => config(props).media.md`
      padding: 180px 0 30px;
    `}
  }
  .quiz-progres-bar,
  .marketing-nav-bar {
    top: ${(props: { isBannerVisible: boolean, isLongBannerText: boolean }): number => props.isBannerVisible ? props.isLongBannerText ? 65 : 32 : 0}px;
    ${(props: any): any => config(props).media.md`
      top: ${(props: { isBannerVisible: boolean }): string => props.isBannerVisible ? '56px' : '0'};
    `}
  }
`

const TagIcon = (): React.ReactNode => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.77167 8.87946L10.7623 17.8699L17.8696 10.7622L8.87183 1.76452H1.91085L1.77167 8.87946ZM10.7623 19.9999C10.5283 19.9999 10.304 19.9069 10.1385 19.7414L0.258529 9.86142C0.08869 9.69202 -0.00461126 9.46042 0.000241289 9.22044L0.163463 0.865016C0.172727 0.384393 0.564902 -6.10352e-05 1.04552 -6.10352e-05H9.23751C9.47131 -6.10352e-05 9.69585 0.0930197 9.86128 0.258447L19.7413 10.1385C20.0858 10.483 20.0858 11.0417 19.7413 11.386L11.3861 19.7414C11.2207 19.9069 10.9961 19.9999 10.7623 19.9999Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.99866 5.62457C6.99866 6.29467 6.4554 6.83771 5.78552 6.83771C5.11543 6.83771 4.57239 6.29467 4.57239 5.62457C4.57239 4.9547 5.11543 4.41144 5.78552 4.41144C6.4554 4.41144 6.99866 4.9547 6.99866 5.62457Z'
        fill='white'
      />
    </svg>
  )
}
